<template>
  <div class="page-container">
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header @toggleSidebar="toggleSidebar" />

    <div class="page-content">
      <Manuscript />
    </div>

    <footer-one />
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Drawer from "@/components/Mobile/Drawer.vue";
import FooterOne from "@/components/Utility/Footer/FooterOne.vue";
import Header from "@/components/Utility/Header/index.vue";
import Manuscript from '@/components/Manuscript/Form.vue';
import { getProfile } from '@/api/user';

export default {
  components: {
    Header,
    FooterOne,
    Drawer,
    Manuscript,
  },
  data: () => ({
    sidebar: false,
    isCheckingAuth: true,
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
    this.checkAuth();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.topToBottom);
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
    async checkAuth() {
      const token = localStorage.getItem('token');
      // 如果没有 token，跳转到登录页
      if (!token) {
        this.redirectToLogin();
        return;
      }

      try {
        const res = await getProfile();
        if (res.code === 200) {
          // token 有效
          this.isCheckingAuth = false;
        } else {
          // token 无效
          localStorage.removeItem('token');
          this.redirectToLogin();
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        localStorage.removeItem('token');
        this.redirectToLogin();
      }
    },
    redirectToLogin() {
      // 获取当前完整路径（包含查询参数）
      const currentPath = this.$route.fullPath;
      // 编码后作为 redirect 参数传递
      const redirect = encodeURIComponent(currentPath);
      this.$router.replace({
        path: '/login',
        query: { redirect }
      });
    }
  },
};
</script>

<style scoped>
.page-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.page-content {
  position: relative;
  width: 100%;
  padding-top: 20px;
}

.global-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center top;
  z-index: -1;
}

.go-top-area {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999;
}

.go-top-btn {
  display: block;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: #1a3a6b;
  color: #fff;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.3s ease;
  font-size: 18px;
}

.go-top-btn.active {
  opacity: 1;
}

.go-top-btn:hover {
  background: #2a5f8f;
  color: #fff;
}
</style>